import gameset from "./gameset";
import TouchZoneBase from '../framework/src/modules/TouchZoneBase';
import Commander from "./Commander";
import {numberFormat} from "../framework/src/helpers";

export default class TouchZone extends TouchZoneBase {

    constructor (config, layers, slots, wallet, symbols, infoPages) {
        super(config, layers, slots, wallet, symbols, gameset);
        this.config = config;
        this.layers = layers;
        this.slots = slots;
        this.infoPages = infoPages;

        this.background = new PIXI.Graphics();

        this.background.beginFill(0x000000, 1);
        this.background.lineStyle(0,0x000000, 1);
        this.background.drawRect(0,0, 1280, 720);
        this.background.endFill();
        this.background.alpha = .5;

        this.layers.winFactors.addChildAt(this.background, 0);
    }

    /**
     *   gameset['game']['layers'][
     *     'black',    - black layer to darken other symbols when clicked
     *      'touchZone' - zones are added here
     *   ];
     *   gameset['game']['symbolModel']['touchZone']: {
     *       width :    - width of the touch zone, center aligned with the symbol
     *       height :   - height of the touch zone, center aligned with the symbol
     *       reels :    - array of the LENGTH defined by the reel COLUMNS COUNT, values [left|right], sets to what side is the frame shifted
     *       table :    - name of the winFactor frame image
     *       numbers :  - name of the winFactor numbers image
     *       font :     - name of the font used
     *       factors :  - amount of non-zero factors
     *   }
     *
     *  HOW TO USE TOUCHZONE:
     *  1. Set all gameset fields ^^ in gameset.js
     *  2. Create layers touchZone and winFactors and add them to gameset
     *  3. Rewrite drawFrame() function. use shiftSprite to position elements (don't forget both orientations!).
     *  4. Access elements using:
     *          -   this.winFactorFrame
     *          -   this.winFactorNumbers
     *          -   this.winFactorSprite
     *          -   this.factorOnSymbols[]
     *  5. When you start spinning and when the round ends use zonesOn(), zonesOff() to disable winFactors during spinning
     *
     */

    /**
     * @override
     * @params symbol - one of the resSymbols that was clicked on, data type is Sprite
     *         orientation - to what side you should shift the frame, values "left" or "right"
     */
    drawFrame(symbol, orientation) {
        if (symbol && symbol.id !== 9) {

            this.creditBet = this.wallet.getCreditBet()


            this.layers.winFactors.alpha = 1;

            if (orientation === "left") {
                this.winFactorFrame.scale.set(1,1);
                this.shiftSprite(this.winFactorFrame, symbol.x, symbol.y, -90, +5);
                this.shiftSprite(this.winFactorNumbers, symbol.x, symbol.y, -260);
            } else {
                this.winFactorFrame.scale.set(-1,1);
                this.shiftSprite(this.winFactorFrame, symbol.x, symbol.y, +90, +5);
                this.shiftSprite(this.winFactorNumbers, symbol.x, symbol.y, +260);
            }

            Commander.removeSprite(this.winFactorSprite);
            this.winFactorSprite = this.factory.createByIndex(symbol.symbolIndex, {});
            this.layers.winFactors.addChild(this.winFactorSprite);
            this.winFactorSprite.position.set(symbol.x, symbol.y);

            let i = 0;
            let factors = this.getSymbolFactor(symbol.name.replace("_blur", "")).factors;
            for (let factor of this.factorOnSymbols) {
                factor.text = (factors[factors.length-i-1]*this.creditBet).toFixed(2)
                factor.scale.set(0.7, 0.7);
                factor.anchor.set(.5, .5);
                if (orientation === "left"){
                    this.shiftSprite(factor ,symbol.x, symbol.y, -170, 56*(i-1) - 10);
                } else {
                    this.shiftSprite(factor, symbol.x, symbol.y, +170, 56*(i - 1) - 10);
                }
                i++;
            }
        }
    }

    /**
     * @override
     */
    onPointerDown() {
    }

    /**
     * @override
     */
    onPointerUp() {
    }
}